var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-header suboverlineCapsReg blackMedium-text py-2"},[_c('v-icon',{staticClass:"blackLow--text ml-5",attrs:{"small":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._v(" "+_vm._s(_vm.header)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }